// extracted by mini-css-extract-plugin
export var category = "ReferenceList-module--category--lszI4";
export var item = "ReferenceList-module--item--fgjf5";
export var itemBrief = "ReferenceList-module--itemBrief--chHEB";
export var itemName = "ReferenceList-module--itemName--auO22";
export var line = "ReferenceList-module--line--WweRI";
export var subcategory = "ReferenceList-module--subcategory--WlAGc";
export var subcategoryList = "ReferenceList-module--subcategoryList--FPKX8";
export var subcategoryTitle = "ReferenceList-module--subcategoryTitle--sP60q";